import React from 'react';

import './scss/loading-rects.css';

const styles = { height: '100vh', width: '100%', position: 'relative' };

const Loading = () => (
  <div style={styles}>
    <div className="spinner">
      <div className="rect1" />
      <div className="rect2" />
      <div className="rect3" />
      <div className="rect4" />
      <div className="rect5" />
    </div>
  </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.jsx